import { createSystem }      from '@chakra-ui/react';
import { defaultConfig }     from '@chakra-ui/react';
import { defineConfig }      from '@chakra-ui/react';
import { defineRecipe }      from '@chakra-ui/react';

export const button = defineRecipe({
	base: {
		fontWeight: 600,
		borderRadius: 8, // <-- border radius is same for all variants and sizes
	},
	variants: {
		variant: {
			solid: {
				bg: 'black',
				color: 'white',
				shadow: '0px 0px 10px #00000029',
				_hover: { bg: 'rgba(0,0,0,0.8)' },
			},
			outline: {
				color: 'rgba(0, 0, 0, 0.8)',
				borderColor: '#00000099',
			},
			ghost: {
				color: 'rgba(0,0,0,0.5)',
			},
		},
	},
});

export const nav = defineRecipe({
	base: {
		height: '72px',
	},
	variants: {
		visual: {
			default: {
				bg: "#1E1E1E",
				lg: { height: "82px" }
			},
			login: {
				height: 105,
				bg: "#F9C39D",
			},
		},
	},
});

const config = defineConfig({
	globalCss: {
		"html, body": {
			bg: "#F1F2F1",
		},
	},
	theme: {
		recipes: { button, nav },
		tokens: {
			colors: {
				black: { value: "#1E1E1E" },
				beige: { value: "#F9C39D" },
				beigeLight: { value: "#FDEDE1" },
				defaultBackground: { value: "#F1F2F1" },
			},
		},
	},
})

export const system = createSystem(defaultConfig, config);

export default system;